import Overview from './Overview'
import withOverview from './withOverview'

const ConnectedOverview = withOverview(Overview)

export { ConnectedOverview as Overview }
